export default __webpack_public_path__ + "static/media/login.a91b75cb.png";